















































import Vue from 'vue'
import AppLayout from '@rhitics/vue/components/AppLayout.vue'

export default Vue.extend({
  name: 'Crawler',

  components: {
    AppLayout
  }
})
